import PropTypes from 'prop-types';
import React from 'react';
import SuperSaleCard from '../card/super_sale_card';
// import { propTypes as rowPropTypes } from './row';
import { getTodaysSuperSale } from '../../utils/super_sale';

export default function SuperSaleRow(props) {
  const { cards } = props;
  const superSaleCard = getTodaysSuperSale(cards);

  return superSaleCard ? (
    <div className="row super-sale-row" >
      <SuperSaleCard {...superSaleCard} type="homepage"/>;
    </div>
  ) : null;
}

// SuperSaleRow.propTypes = Object.assign({ ...rowPropTypes }, {
//   cards: PropTypes.array.isRequired
// });
